"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddRowSelectColumn = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TableProps = require("../TableProps");
var _RowSelectCheckbox = require("./RowSelectCheckbox");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const AddRowSelectColumn = _ref => {
  let {
    hooks,
    tableId
  } = _ref;
  const {
    visibleColumns,
    rows
  } = hooks;
  const columnId = "".concat(tableId, "_rowSelectionColumn");
  const HandleSelectAll = (event, changeFunc) => {
    // eslint-disable-next-line no-console
    console.log('All');
    changeFunc(event);
  };
  const HandleSelectRow = (event, row) => {
    // eslint-disable-next-line no-console
    console.log('Row');
  };
  const RenderHeaderSelector = _ref2 => {
    let {
      getToggleAllRowsSelectedProps
    } = _ref2;
    const allProps = getToggleAllRowsSelectedProps();
    const {
      checked,
      onChange,
      indeterminate
    } = allProps;
    return /*#__PURE__*/_react.default.createElement(_RowSelectCheckbox.RowSelectCheckbox, _extends({}, allProps, {
      indeterminate: indeterminate,
      rowId: "".concat(columnId, "_header"),
      id: "".concat(columnId, "_header"),
      onClickHandler: onChange,
      checked: checked
    }));
  };
  RenderHeaderSelector.propTypes = {
    getToggleAllRowsSelectedProps: _propTypes.default.func
  };
  const RenderCellSelector = _ref3 => {
    let {
      row
    } = _ref3;
    const allProps = row.getToggleRowSelectedProps();
    const {
      checked,
      indeterminate
    } = allProps;
    return /*#__PURE__*/_react.default.createElement(_RowSelectCheckbox.RowSelectCheckbox, _extends({}, allProps, {
      indeterminate: indeterminate,
      rowId: "".concat(columnId, "_row_").concat(row.id),
      id: "".concat(columnId, "_row_").concat(row.id),
      onClickHandler: event => HandleSelectRow(event, row),
      checked: checked
    }));
  };
  RenderCellSelector.propTypes = {
    row: _TableProps.TableRowProps
  };
  visibleColumns.push(columns => {
    return [{
      id: columnId,
      isSelectorColumn: true,
      cssClass: 'rowSelectColumn',
      Header: _ref4 => {
        let {
          getToggleAllRowsSelectedProps
        } = _ref4;
        return RenderHeaderSelector({
          getToggleAllRowsSelectedProps
        });
      },
      Cell: _ref5 => {
        let {
          row
        } = _ref5;
        return RenderCellSelector({
          row
        });
      }
    }, ...columns];
  });
};
exports.AddRowSelectColumn = AddRowSelectColumn;
AddRowSelectColumn.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  hooks: _propTypes.default.any,
  tableId: _propTypes.default.string
};